export const DennerTheme = {
  name: 'Denner Theme',
  themeId: 'denner',
  colors: {
    brand: {
      primary: {
        100: '#FF0000'
      },
      secondary: {
        100: '#212529'
      },
      accent: {
        100: '#363636'
      }
    }
  },
  fonts: {
    families: {
      text: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      condensed: '"Gotham Narrow-Blackitalic", "Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      notes: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      heading: '"Gotham Narrow-Blackitalic", "Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      subHeading: '"Gotham Narrow-Blackitalic", "Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      display: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articleText: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articleHeading: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articlePrice: '"Gotham Pro", "Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif'
    },
    sizes: {
      heading: {
        medium: '44px'
      }
    }
  }
};